import { Components, Theme } from '@mui/material';

export const appBarStyles: Components<Theme>['MuiAppBar'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: theme.palette.customGrey.dark,
      padding: '11px 50px',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: '40px',
      overflow: 'hidden',
      border: 'none'
    })
  }
};
